var exports = {
  "kL": "x31de4314--e5a2e9--container",
  "Lh": "x31de4314--e5a2e9--container-economy",
  "RG": "x31de4314--e5a2e9--container-safety",
  "vW": "x31de4314--e5a2e9--inner",
  "RJ": "x31de4314--e5a2e9--description-wrapper",
};

module.exports = exports;
